<template>
    <div class="d-flex flex-column edit-title-form event-photo">
        <p class="edit-title">Add event picture/video</p>
        <img
            v-if="!image"
            :src="getIcon + 'default-artist-event.png'"
            @click="uploadImage"
            class="upload-image"
        />
        <img v-if="image" :src="image" @click="uploadImage" class="upload-image" />
        <input
            @change="selectFile($event)"
            hidden
            ref="photoUpload"
            type="file"
            class="photo-dwnld"
        />
        <button @click="uploadImageRequest" class="save-title-btn">Set</button>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../../helpers/notification'

    export default {
        name: 'AddEventImage',
        props: {
            eventInfo: {
                type: Object
            }
        },
        data: () => ({
            formData: {
                medias: []
            },
            image: null
        }),
        methods: {
            uploadImage() {
                this.$refs.photoUpload.click()
            },
            selectFile(event) {
                const file = event.target.files[0]

                const reader = new FileReader()

                reader.onloadend = () => {
                    this.image = reader.result
                }

                reader.readAsDataURL(file)
            },
            uploadImageRequest() {
                axios
                    .put('/event/manage/update/' + this.eventInfo.id, { image: this.image })
                    .then((response) => {
                        if (response.status === 200) {
                            const newEventData = {
                                id: this.eventInfo.id,
                                image: this.image
                            }
                            this.$emit('updateEventData', newEventData)
                        }
                        notification('success', response.data.message)
                    })
                    .catch((error) => {
                        notification('error', error)
                    })
            }
        },
        computed: {
            getIcon() {
                return '/images/'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .photo-dwnld {
        border-radius: 10px;
        border: 1.5px solid #8b8b8b;
        max-width: 100%;
        max-height: 40%;
        flex-shrink: 0;
        margin-left: 25px;
    }
    .upload-image {
        border-radius: 10px;
        border: 1px solid #8b8b8b;
        filter: brightness(55%);
        cursor: pointer;
        max-width: 320px;
        max-height: 330px;
        object-fit: cover;
        margin-top: 25px;
    }
    .event-photo::before {
        content: 'Add/Select Image';
        position: absolute;
        top: 50%;
        left: 45%;
        transform: translate(-120%, -170%);
        color: #dedede;
        text-align: center;
        font-size: 22px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
        z-index: 999;
    }
    .input-img {
        background: url('/images/default-artist-event.png');
        background-size: cover;
        background-repeat: no-repeat;
    }
    .edit-title {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .save-title-btn {
        align-items: center;
        background: #cdeb09;
        border: 0;
        border-radius: 100px;
        display: inline-flex;
        gap: 10px;
        justify-content: center;
        letter-spacing: 1.8px;
        padding: 20px;
        text-align: center;
        text-transform: uppercase;
        width: 100%;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        margin-top: 48px;
    }
    .view-carousel {
        flex: 0 0 auto;
        display: flex;
    }
</style>
